import States from 'components/feedback/States';
import type React from 'react';
import type { ReactNode } from 'react';

interface NoContentProps {
    testId?: string;
    title?: string;
    body?: string | React.JSX.Element;
    button?: ReactNode;
}

const NoContent = ({
    testId,
    title = 'Nothing to show here yet',
    body = 'There is no data to display.',
    button,
}: NoContentProps) => (
    <States
        data-testid={testId}
        icon={
            <span className='DataTableEmptyState__icon rioglyph rioglyph-looking-glass-man margin-bottom-20 text-color-light' />
        }
        title={title}
        body={body}
        button={button}
    />
);

export default NoContent;
